import React, { useState } from 'react';
import logo from './logo.png';
import { Button } from '@fluentui/react-components';
import {
  Navigation24Regular,
  MailFilled,
  SearchFilled,
  SearchInfoFilled,
  OrganizationFilled,
  PeopleFilled,
  ScalesFilled,
  TicketDiagonalFilled
} from '@fluentui/react-icons';

interface NavBarProps {
  showHome?: boolean;
}

const NavBar: React.FC<NavBarProps> = ({ showHome = true }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isProductsMenuOpen, setIsProductsMenuOpen] = useState(false);
  const [isSolutionsMenuOpen, setIsSolutionsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(prev => !prev);
  const toggleProductsMenu = () => setIsProductsMenuOpen(prev => !prev);
  const closeProductsMenu = () => setIsProductsMenuOpen(false);
  const toggleSolutionsMenu = () => setIsSolutionsMenuOpen(prev => !prev);
  const closeSolutionsMenu = () => setIsSolutionsMenuOpen(false);

  return (
    <nav className="top-nav">
      <div className="nav-container">
        <div className="logo">
          <a href="/" aria-label="Meta-365 home">
            {/* Above the fold on every page - must not be lazy or it delays first paint. */}
            <img loading="eager" decoding="async" src={logo} alt="Meta-365" style={{ cursor: 'pointer' }} />
          </a>
        </div>
        <Button
          className="menu-toggle"
          onClick={toggleMenu}
          appearance="subtle"
          icon={<Navigation24Regular />}
        />
        <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          {showHome && (
            <li><a className="nav-link" href="/">Home</a></li>
          )}
          <li
            className="nav-menu-item-with-submenu"
            onMouseEnter={toggleSolutionsMenu}
            onMouseLeave={closeSolutionsMenu}
            onClick={(e) => {
              if (window.innerWidth <= 768) {
                e.stopPropagation();
                toggleSolutionsMenu();
              }
            }}
          >
            <span>Solutions</span>
            <ul className={`submenu ${isSolutionsMenuOpen ? 'active' : ''}`}>
              <li>
                <a className="nav-link" href="/the-challenge">
                  <SearchInfoFilled className="submenu-icon" />
                  <span>The Challenge</span>
                </a>
              </li>
              <li>
                <a className="nav-link" href="/solutions/automation">
                  <OrganizationFilled className="submenu-icon" />
                  <span>Automate with AI Agents</span>
                </a>
              </li>
              <li>
                <a className="nav-link" href="/solutions/hr-template">
                  <PeopleFilled className="submenu-icon" />
                  <span>Transform HR Operations</span>
                </a>
              </li>
              <li>
                <a className="nav-link" href="/solutions/case-management">
                  <ScalesFilled className="submenu-icon" />
                  <span>Legal Case Management</span>
                </a>
              </li>
              <li>
                <a className="nav-link" href="/solutions/ticketing">
                  <TicketDiagonalFilled className="submenu-icon" />
                  <span>Service Ticketing</span>
                </a>
              </li>
            </ul>
          </li>
          <li
            className="nav-menu-item-with-submenu"
            onMouseEnter={toggleProductsMenu}
            onMouseLeave={closeProductsMenu}
            onClick={(e) => {
              if (window.innerWidth <= 768) {
                e.stopPropagation();
                toggleProductsMenu();
              }
            }}
          >
            <span>Our Products</span>
            <ul className={`submenu ${isProductsMenuOpen ? 'active' : ''}`}>
              <li className="submenu-featured">
                <a className="nav-link" href="/solutions/pentities">
                  <OrganizationFilled className="submenu-icon submenu-icon-featured" />
                  <span>pEntities</span>
                </a>
              </li>
              <li>
                <a className="nav-link" href="/solutions/pshareemail">
                  <MailFilled className="submenu-icon" />
                  <span>PShareEmail</span>
                </a>
              </li>
              <li>
                <a className="nav-link" href="/solutions/docsearch">
                  <SearchFilled className="submenu-icon" />
                  <span>DocSearch Tool</span>
                </a>
              </li>
              <li>
                <a className="nav-link" href="/solutions/searchassistant">
                  <SearchInfoFilled className="submenu-icon" />
                  <span>Search Assistant</span>
                </a>
              </li>
            </ul>
          </li>
          <li><a className="nav-link" href="/about">About</a></li>
          <li>
            <a className="nav-link" href="/contactus">
              <Button className="cta-button" appearance="primary">
                Contact Us
              </Button>
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default NavBar;
